import styled from 'styled-components'
import { skeletonAnimation } from 'src/styles'

export const Wrapper = styled.div`
  gap: var(--spacer-2);
  overflow-x: auto;
  white-space: nowrap;
  position: relative;
  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`

Wrapper.displayName = 'Wrapper'

export const Option = styled.div`
  height: 1.75rem;
  width: 100px;
  ${skeletonAnimation}
`

Option.displayName = 'Option'
